import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx';
import services from '../../services/allservices.jsx';
import Loader from '../loader/loader.jsx';
import GusetNavbar from '../navigation/guestnavbar';

import CardNumber from './cardnumber.jsx';
import Signin from './signin.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import android from '../../images/android.png';
import ios from '../../images/ios.png';

import {
    Link, withRouter
} from 'react-router-dom';


import carousel1 from '../../images/carousel-1.jpg';
import carousel2 from '../../images/carousel-5.jpg';
import carousel3 from '../../images/carousel-3.jpg';
import carousel4 from '../../images/carousel-8.jpg';

import carousel5 from '../../images/carousel-6.jpg';
import carousel6 from '../../images/carousel-2.jpg';
import carousel7 from '../../images/carousel-7.jpg';
import carousel8 from '../../images/carousel-4.jpg';

import activateImg from '../../images/iconShopping.svg';
import customerImg from '../../images/iconCustomersupport.svg';
import manageImg from '../../images/icoAccount.png';
import highlitedtext from '../../images/highlitedau.png';
import aucardholder from '../../images/aucardholder.png';
import nzcardholder from '../../images/nzcardholder.png';
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    managestate: state.Manage.managestate

})

const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchManageInform(managestate) {
        dispatch(
            actions.ManageAction(managestate)
        )
    }
})

// const JSEncrypt = window.JSEncrypt
class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            userName: '',
            password: '',
            toggleTypeForOtp: "password",
            toggleTextForOtp: "password",
            toggleIconForOtp: "fa fa-eye-slash",
            togglePassIconForOtp: "fa fa-eye-slash",
            disabled: true,
            toggleType: "password",
            toggleText: "password",
            toggleIcon: "fa fa-eye-slash",
            togglePassIcon: "fa fa-eye-slash",
            showModal: false,
            rndInt: 0,
            otp: "",

            toggleTypeForOtp: "password",
            toggleTextForOtp: "password",
            toggleIconForOtp: "fa fa-eye-slash",
            togglePassIconForOtp: "fa fa-eye-slash",

            userValidated: false,
            encryptedAccountID: '',
            maskedEmailID: '',
            otpDisabled: true,

            timer: 180,

        };
        this.handleBlur = this.handleBlur.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        // this.handleLogin = this.handleLogin.bind(this)
        this.updateWindowDimentions = this.updateWindowDimentions.bind(this);
        this.handleLoginWithPassword = this.handleLoginWithPassword.bind(this)
        this.handleLoginWithOTP = this.handleLoginWithOTP.bind(this)

    }
    componentDidMount() {
        this.props.fetchPublicKey(false)
        this.updateWindowDimentions();
        window.addEventListener('resize', this.updateWindowDimentions);
        localStorage.setItem('landingTabs', 'cardNo')
        localStorage.setItem("landing", true)
        this.setState({ rndInt: this.randomIntFromInterval(1, 3) }, () => {
            console.log(this.state.rndInt)
        })

        $(document).ready(function () {
            $("div.bhoechie-tab-menu>div.list-group>a").click(function (e) {
                e.preventDefault();
                $(this).siblings('a.active').removeClass("active");
                $(this).addClass("active");
                var index = $(this).index();
                $("div.bhoechie-tab>div.bhoechie-tab-content").removeClass("active");
                $("div.bhoechie-tab>div.bhoechie-tab-content").eq(index).addClass("active");
            });
        });
    }
    randomIntFromInterval = (min, max) => { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    onSuggestSelect(suggest) {

    }
    changeToEditView(e) {
        this.setState({ addressComp: false })
    }
    handleBlur() {
        this.setState({ addressComp: true })
    }
    handleDate(e, date) {
        this.setState({
            dateofbirth: date.toString()
        })
    }
    handleSelect(event, index, value) {
        this.setState({
            gender: value
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }
    handleClick = () => {
        localStorage.setItem('landingTabs', 'userName1')
        this.setState({
            landingTabs: 'userName1'
        })
    }
    handleRegister = () => {
        localStorage.setItem('landingTabs', 'cardNo')
        this.setState({
            landingTabs: 'cardNo'
        })
    }
    componentWillReceiveProps(nextProps) {

    }
    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }


    toggleForOtp = () => {
        this.setState((prevState) => ({
            toggleTypeForOtp:
                prevState.toggleTypeForOtp === "password"
                    ? "text"
                    : "password",

            toggleIconForOtp:
                prevState.toggleTypeForOtp === "password"
                    ? "fa fa-fw fa-eye"
                    : "fa fa-eye-slash",
        }));
    };






    handleValidateUsername = (e, value) => {
        const inputValue = value || "";
        this.setState(
            {
                userName: inputValue,
            },
            () => {
                if (
                    this.state.userName.length !== 0 &&
                    this.state.password.length !== 0
                ) {
                    this.setState({ disabled: false });
                } else {
                    this.setState({ disabled: true });
                }
            }
        );
    };


    handleValidatePassword = (e, value) => {
        const inputValue = value || "";
        this.setState(
            {
                password: inputValue,
            },
            () => {
                if (
                    this.state.userName.length !== 0 &&
                    this.state.password.length !== 0
                ) {
                    this.setState({ disabled: false });
                } else {
                    this.setState({ disabled: true });
                }
            }
        );
    };

    handelValidateOtp = (e, value) => {
        if (e.target.name === "otp" && value.length !== 0) {
            // Allow only numbers
            const otpValue = value.replace(/[^0-9]/g, "");

            this.setState(
                {
                    otp: otpValue,
                },
                () => {
                    if (this.state.otp.length === 6) {
                        this.setState({
                            otpDisabled: false,
                        });
                    } else {
                        this.setState({
                            otpDisabled: true,
                        });
                    }
                }
            );
        } else {
            this.setState({
                otp: "",
                otpDisabled: true,
            });
        }
    };
    toggleForOtp = () => {
        this.setState((prevState) => ({
            toggleTypeForOtp:
                prevState.toggleTypeForOtp === "password" ? "text" : "password",
            toggleIconForOtp:
                prevState.toggleTypeForOtp === "password"
                    ? "fa fa-fw fa-eye"
                    : "fa fa-eye-slash",
        }));
    };
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimentions);
        clearInterval(this.otpInterval);
    }

    updateWindowDimentions() {
        this.setState({
            width: window.innerWidth + 'px',
            height: (window.innerHeight - 220) + 'px'
        })
        console.log("Size :", `${this.state.width} x ${this.state.height} `)
    }
    handleClose = () => {
        document.getElementById("myModal").style.display = "none"
        window.scrollBy(0, 750)
    }
    // handleLogin(e) {
    //     // const {correctPassword ,correctUsername} = this.state
    //     // if (correctUsername === false) {
    //     //     this.setState({
    //     //         correctUsername: false
    //     //     })
    //     // }
    //     // else if (correctPassword === false) {
    //     //     this.setState({
    //     //         correctPassword: false
    //     //     })
    //     // }


    //     // else {
    //     this.setState({
    //         loader: true
    //     })
    //     // if (publicKey.status === 200) {
    //     //     const public_Key = publicKey.body.publickey;
    //     //     let encrypt = new JSEncrypt();
    //     //     encrypt.setPublicKey(public_Key);

    //     let _this = this
    //     let state = {
    //         userName: this.state.userName,
    //         password: this.state.password,
    //         otp: this.state.otp,
    //         mobileNumber: this.state.mobileNumber,
    //         applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
    //     }
    //     let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
    //     let gid = getClientId();
    //     let traceId = getClientId();


    //     fetch(plink + services.loginBasedOnOTPPassword, {
    //         method: 'POST',
    //         headers: new Headers({
    //             'Content-Type': 'application/json',
    //             'clientId': gid,
    //             'clientSecret': getClientSecret(gid, this.state.userName),
    //             'X-Trace-Id': traceId,
    //             'X-KlickEx-Client': buildClientHeader(),
    //         }),
    //         body: JSON.stringify(state)
    //     })
    //         .then(
    //             function (response) {
    //                 if (response.status === 200 || response.status === 201) {

    //                     if (_this.state.userName === 'admin' && _this.state.password === 'Qwerty@1') {
    //                         response.json().then(function (json) {
    //                             let exp = json.expiryInMinutes

    //                             let expiry = (exp * 60000 + new Date().getTime())

    //                             localStorage.setItem('expiryTime', JSON.stringify(expiry))
    //                             localStorage.setItem("loginState", true)
    //                             localStorage.setItem('memberId', json.memberId);
    //                             localStorage.setItem('token', json.token)
    //                             localStorage.setItem('accountId', json.accountId);
    //                             localStorage.setItem('timeoutvalue', 'first')


    //                             localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
    //                             localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
    //                             localStorage.setItem('cardTypes', json.cardTypes)
    //                             localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)
    //                             _this.setState({
    //                                 loader: false,
    //                             })
    //                             toast.success(response.headers.get('message'), {
    //                                 position: "top-right",
    //                                 draggablePercent: 60,
    //                                 autoClose: 3000,
    //                                 hideProgressBar: false,
    //                                 closeOnClick: true,
    //                                 pauseOnHover: true,
    //                                 draggable: false
    //                             });

    //                             setTimeout(function () {
    //                                 _this.props.history.push('/cardsearch');

    //                             }, 1000);
    //                         })
    //                     }
    //                     else {
    //                         response.json().then(function (json) {
    //                             let exp = json.expiryInMinutes

    //                             let expiry = (exp * 60000 + new Date().getTime())

    //                             localStorage.setItem('expiryTime', JSON.stringify(expiry))
    //                             localStorage.setItem("loginState", true)
    //                             localStorage.setItem('memberId', json.memberId);
    //                             localStorage.setItem('token', json.token)
    //                             localStorage.setItem('accountId', json.accountId);
    //                             localStorage.setItem('cardTypes', json.cardTypes)
    //                             localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
    //                             localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
    //                             localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)


    //                             if (json.performChangePassword === true) {
    //                                 setTimeout(function () {
    //                                     _this.props.history.push('/fchangepassword');
    //                                 }, 3000);
    //                             }
    //                             else if (json.performForceSecretQuestion === true) {
    //                                 setTimeout(function () {
    //                                     _this.props.history.push('/ForceChangesecretque');
    //                                 }, 3000);
    //                             }
    //                             else {
    //                                 // _this.setState({
    //                                 //     loader: false
    //                                 // })
    //                                 _this.setState({
    //                                     loader: false,
    //                                     userName: "",
    //                                     password: "",
    //                                     otp: "",
    //                                     validatedUserId: false
    //                                 })
    //                                 toast.success(response.headers.get('message'), {
    //                                     position: "top-right",
    //                                     draggablePercent: 60,
    //                                     autoClose: 3000,
    //                                     hideProgressBar: false,
    //                                     closeOnClick: true,
    //                                     pauseOnHover: true,
    //                                     draggable: false
    //                                 });

    //                                 setTimeout(function () {
    //                                     _this.props.history.push('/home');
    //                                     localStorage.setItem("landing", false)
    //                                 }, 500);


    //                             }



    //                             // _this.props.history.push('/home');
    //                         })
    //                     }
    //                 }
    //                 else if (response.status === 417) {
    //                     _this.setState({
    //                         loader: false
    //                     })
    //                     document.getElementById("myModal").style.display = "block"

    //                 }
    //                 // else if (response.status === 422) {
    //                 //     // response.json()
    //                 //     //     .then(json => {
    //                 //     //         let message = json.message ? json.message : response.headers.get('message')
    //                 //     //         //document.getElementById('setpassword').style.display = "block"

    //                 //     //         _this.setState({
    //                 //     //             loader: false
    //                 //     //         })
    //                 //     //         // setTimeout(function () { window.location.reload(true) }, 100) 
    //                 //     //     })
    //                 //     _this.setState({
    //                 //         loader: false
    //                 //     })
    //                 //     toast.error(response.headers.get('message'), {
    //                 //         position: "top-right",
    //                 //         autoClose: 3000,
    //                 //         hideProgressBar: false,
    //                 //         closeOnClick: true,
    //                 //         pauseOnHover: true,
    //                 //         draggable: true,
    //                 //         draggablePercent: 60
    //                 //     })
    //                 // }
    //                 else if (response.status === 422) {

    //                                                                                 _this.setState({
    //                                                                                     // popupLoader: false,
    //                                                                                     loader: false,
    //                                                                                 });

    //                                                                                 let message = response.headers.get("message");

    //                                                                                 response.json().then((json) => {
    //                                                                                 message = json.message
    //                                                                                     ? json.message
    //                                                                                     : response.headers.get("message");

    //                                                                                 toast.error(message, {
    //                                                                                     position: "top-right",
    //                                                                                     autoClose: 3000,
    //                                                                                     hideProgressBar: false,
    //                                                                                     closeOnClick: true,
    //                                                                                     pauseOnHover: true,
    //                                                                                     draggable: true,
    //                                                                                     draggablePercent: 60,
    //                                                                                 });
    //                                                                                 });

    //                                                                                 toast.error(message, {
    //                                                                                     position: "top-right",
    //                                                                                     autoClose: 3000,
    //                                                                                     hideProgressBar: false,
    //                                                                                     closeOnClick: true,
    //                                                                                     pauseOnHover: true,
    //                                                                                     draggable: true,
    //                                                                                     draggablePercent: 60,
    //                                                                                 });

    //                                                                             }
    //                 else {
    //                     _this.setState({
    //                         loader: false
    //                     })

    //                     toast.error(response.headers.get('message'), {
    //                         position: "top-right",
    //                         draggablePercent: 60,
    //                         autoClose: 3000,
    //                         hideProgressBar: false,
    //                         closeOnClick: true,
    //                         pauseOnHover: true,
    //                         draggable: false
    //                     });
    //                     // setTimeout(function () { window.location.reload(true) }, 100)
    //                 }
    //             }
    //         )
    //     // }
    // }
    handleLoginWithPassword(e) {
        this.setState({
            loader: true
        })


        let gid = getClientId()
        let traceId = getClientId()
        let _this = this
        let state = {
            userName: this.state.userName,
            password: this.state.password,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        // fetch(services.loginWithPassword, {
        let plink =
            localStorage.getItem('pform') === 'AU'
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        fetch(plink + services.loginWithPassword, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.userName),
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201) {


                        //                     response.json().then(function (json) {

                        //                         localStorage.setItem('emailID', json.emailId);
                        //                         const responseEncryptedAccountID = json.accountId || '';
                        //                         const responseEmailID = json.emailId || '';
                        //                             _this.setState({
                        //                                 loader: false,
                        //                                 userValidated:true,
                        //                                 encryptedAccountID:responseEncryptedAccountID,
                        //                                 maskedEmailID: responseEmailID,
                        //                             })

                        // _this.startTimer();
                        //                             // toast.success(response.headers.get('message'), {
                        //                             //     position: "top-right",
                        //                             //     draggablePercent: 60,
                        //                             //     autoClose: 3000,
                        //                             //     hideProgressBar: false,
                        //                             //     closeOnClick: true,
                        //                             //     pauseOnHover: true,
                        //                             //     draggable: false
                        //                             // });


                        //                     })
                        response.json().then(function (json) {
                            localStorage.setItem('emailID', json.emailId);
                            const responseEncryptedAccountID = json.accountId || '';
                            const responseEmailID = json.emailId || '';


                            if (json.byPassLoginOtp === true) {


                                let exp = json.expiryInMinutes;
                                let expiry = (exp * 60000 + new Date().getTime());
                                localStorage.setItem('otpValidation', json.otpValidation);
                                localStorage.setItem('expiryTime', JSON.stringify(expiry));
                                localStorage.setItem("loginState", true);
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token);
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('cardTypes', json.cardTypes);
                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested);

                                _this.setState({ loader: false }, () => {

                                    if (json.performChangePassword === true) {
                                        setTimeout(function () {
                                            _this.props.history.push('/fchangepassword');
                                        }, 3000);
                                    }
                                    else if (json.performForceSecretQuestion === true) {
                                        setTimeout(function () {
                                            _this.props.history.push('/ForceChangesecretque');
                                        }, 3000);
                                    }
                                    else {
                                        toast.success(response.headers.get('message'), {
                                            position: "top-right",
                                            draggablePercent: 60,
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: false
                                        });

                                        setTimeout(function () {
                                            _this.props.history.push('/home');
                                            localStorage.setItem("landing", false);
                                        }, 3000);
                                    }
                                });

                            } else {

                                _this.setState({
                                    loader: false,
                                    userValidated: true,
                                    encryptedAccountID: responseEncryptedAccountID,
                                    maskedEmailID: responseEmailID,
                                });
                                _this.startTimer();
                            }
                        })
                    }
                    else if (response.status === 417) {
                        _this.setState({
                            loader: false
                        })
                        document.getElementById("myModal").style.display = "block"
                    }
                    else if (response.status === 422) {
                        _this.setState({
                            loader: false,
                        });
                        let message = response.headers.get("message");

                        response.json()
                            .then((json) => {
                                if (json && json.message) {
                                    message = json.message;
                                }
                                toast.error(message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60,
                                });
                            })
                            .catch(() => {
                                toast.error(message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60,
                                });
                            });



                    }
                    else {
                        _this.setState({
                            loader: false
                        })

                        toast.error(response.headers.get('message') || 'Something went wrong', {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
        // }
    }
    handleLoginWithOTP(e) {
        this.setState({
            loader: true
        })


        let gid = getClientId()
        let traceId = getClientId()
        let _this = this
        let state = {
            accountId: this.state.encryptedAccountID,
            otp: this.state.otp,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        // fetch(services.loginWithOTP, {
        let plink =
            localStorage.getItem('pform') === 'AU'
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        fetch(plink + services.loginWithOTP, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.encryptedAccountID),
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })

            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201) {

                        if (_this.state.userName === 'admin' && _this.state.password === 'Qwerty@1') {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())
                                 localStorage.setItem('otpValidation', json.otpValidation);
                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('timeoutvalue', 'first')


                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)
                                _this.setState({
                                    loader: false,
                                })
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () {
                                    _this.props.history.push('/cardsearch');

                                }, 3000);
                            })
                        }
                        else {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())
                                localStorage.setItem('otpValidation', json.otpValidation);
                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)


                                if (json.performChangePassword === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/fchangepassword');
                                    }, 3000);
                                }
                                else if (json.performForceSecretQuestion === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/ForceChangesecretque');
                                    }, 3000);
                                }
                                else {
                                    // _this.setState({
                                    //     loader: false
                                    // })
                                    _this.setState({
                                        loader: false,
                                        userName: "",
                                        password: "",
                                        otp: "",
                                        validatedUserId: false
                                    })
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });

                                    setTimeout(function () {
                                        _this.props.history.push('/home');
                                        localStorage.setItem("landing", false)
                                    }, 3000);


                                }



                                // _this.props.history.push('/home');
                            })
                        }
                    }
                    else if (response.status === 417) {
                        _this.setState({
                            loader: false
                        })
                        document.getElementById("myModal").style.display = "block"

                    }
                    // else if (response.status === 422) {
                    //     // response.json()
                    //     //     .then(json => {
                    //     //         let message = json.message ? json.message : response.headers.get('message')
                    //     //         //document.getElementById('setpassword').style.display = "block"

                    //     //         _this.setState({
                    //     //             loader: false
                    //     //         })
                    //     //         // setTimeout(function () { window.location.reload(true) }, 100) 
                    //     //     })
                    //     _this.setState({
                    //         loader: false
                    //     })
                    //     toast.error(response.headers.get('message'), {
                    //         position: "top-right",
                    //         autoClose: 3000,
                    //         hideProgressBar: false,
                    //         closeOnClick: true,
                    //         pauseOnHover: true,
                    //         draggable: true,
                    //         draggablePercent: 60
                    //     })
                    // }
                    else if (response.status === 422) {

                        _this.setState({
                            // popupLoader: false,
                            loader: false,
                        });

                        let message = response.headers.get("message");

                        response.json().then((json) => {
                            message = json.message
                                ? json.message
                                : response.headers.get("message");

                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60,
                            });
                        });

                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });

                    }
                    else {
                        _this.setState({
                            loader: false
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        // setTimeout(function () { window.location.reload(true) }, 100)
                    }
                }
            )
    }
    // Resend OTP
    handleResend = () => {



        this.handleResendOTP();
    };
    handleResendOTP = () => {
        let _this = this;
        let state = {
            accountId: this.state.encryptedAccountID,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            reSendOtp: true
        };
        _this.setState({
            loader: true,
        });
        let gid = getClientId()
        let traceId = getClientId()
        // fetch(services.resendOTPForLogin, {
        let plink =
            localStorage.getItem('pform') === 'AU'
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        fetch(plink + services.resendOTPForLogin, {
            method: "POST",
            headers: new Headers({
                "Content-Type": 'application/json',
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.encryptedAccountID),
            }),
            body: JSON.stringify(state),
        }).then(function (response) {
            if (
                response.status === 200 ||
                response.status === 201 ||
                response.status === 204
            ) {
                _this.setState({
                    loader: false,
                    timer: 180, //3 mins
                    otp: "",
                    otpDisabled: false,
                });

                _this.startTimer();

                toast.success(response.headers.get("message"), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                });
            } else if (response.status === 422) {
                _this.setState({
                    loader: false,
                });
                let message = response.headers.get("message");

                response.json()
                    .then((json) => {
                        if (json && json.message) {
                            message = json.message;
                        }
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });
                    })
                    .catch(() => {
                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });
                    });
            } else {
                toast.error(response.headers.get("message") || 'Something went wrong', {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                });
                _this.setState({
                    loader: false,
                });
            }
        });
    };
    startTimer = () => {
        this.interval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.timer <= 1) {
                    clearInterval(this.interval);
                    return { timer: 0 };
                }

                return {
                    timer: prevState.timer - 1,
                };
            });
        }, 1000);
    };
    formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;

        return `${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds
            }`;
    };
    toggle = () => {

        if (this.state.toggleType === "password") {
            this.setState({
                toggleType: "text",
                toggleIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleType: "password",
                toggleIcon: "fa fa-eye-slash"
            })
        }
    }

    onFieldChange = (e, value) => {
        this.setState({
            email: value
        }, () => {
            console.log(this.state.email)
        })
    }

    toggleModal = () => this.setState({
        showModal: !this.state.showModal
    })

    handleSendLink = () => {
        let _this = this
        let state = {
            emailId: this.state.email
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ

        let gsid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.send_api_link, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gsid,
                'clientSecret': getClientSecret(gsid, this.state.emailId),
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                        _this.setState({
                            showModal: false,
                            email: '',
                        })
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else if (response.status === 400) {
                        toast.error("Incorrect Email ID.", {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
    }

    render() {
        const { loader } = this.state

        return (
            <div className="" >
                <section className="row mb-3" id="statictopbar" style={{ padding: "15px 0px", background: '#0190f7' }}>
                    <div className="col-sm-12" > </div>
                </section>
                <GusetNavbar />
                <div className="" style={{ backgroundColor: 'transparent' }}>

                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />
                    <div

                        className={`modal WelcomeModal ${this.state.showModal ? 'show' : ''}`}
                        style={{
                            display: `${this.state.showModal ? 'block' : 'none'}`,
                            backgroundColor: "rgba(12,12,12,.5)"
                        }}
                        id="WelcomeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header" style={{ borderBottom: "0px" }}>
                                    <div className="camera-box">
                                        <h5 className="modal-title" id="exampleModalLabel">Download Mobile App</h5>
                                    </div>
                                    <button type="button" class="close" onClick={this.toggleModal} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>The SIMS Visa Prepaid App is now available.  You can download the mobile App by clicking on the logos below. </p>
                                    <div className="col-sm-12 ">
                                        <div className="row">
                                            <div className="col-sm-8" style={{ paddingLeft: "5px" }} >

                                                <TextField
                                                    hintText="Email"
                                                    floatingLabelText="Email"
                                                    type="text"
                                                    name="email"
                                                    maxLength="50"
                                                    autoComplete='off'
                                                    onChange={this.onFieldChange}
                                                    className="my-className"
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    autoFocus={true}
                                                    fullWidth
                                                />

                                            </div>
                                            <div className="col-sm-4" style={{ marginTop: "25px", padding: "0px" }}>
                                                <RaisedButton
                                                    label="Send App Link"
                                                    labelColor="#000"
                                                    className="btn-std"
                                                    // style={styles.buttonStyle}
                                                    buttonStyle={{ height: "30px", lineHeight: "0px" }}
                                                    labelStyle={{ paddingLeft: "12px", paddingRight: "12px", textTransform: "capitalize" }}
                                                    onClick={this.handleSendLink.bind(this)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <p className='mt-4 pb-1'><a href="https://play.google.com/store/apps/details?id=com.oxy.sims" target="_blank"><img src={android} style={{ height: '55px', marginRight: "6px" }} /></a> <a href="https://apps.apple.com/in/app/simsmetal/id1670414151" target="_blank"><img src={ios} style={{ height: '55px' }} /> </a></p>
                                    <p className='mt-1 pb-1'>On the App, you can perform all the functions that are available on the website klickex.co.nz such as Card Activation, Registration, Lock/Unlock card, Change PIN, Transaction History, Print Statement and much more.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 cardbgAU'>
                        <div className='container bgtransparent'>
                            <div className="col-sm-12 " >
                                <div className="row" >
                                    <div className="col-md-6 card-images pl-4 pr-0 pt-2" >
                                        <h2> KlickEx Money Card</h2>
                                        <h2> makes using your</h2>
                                        <h2> money in {localStorage.getItem('pform') === 'AU' ? <span>Australia <img className='highlitedau' src={highlitedtext} alt='australia' /></span> : <span>New Zealand <img className='highlitedau' src={highlitedtext} alt='New Zealand' /></span>}</h2>
                                        <h2> a breeze</h2>
                                        <div className='col-md-12' >
                                            {localStorage.getItem('pform') === 'AU' ?
                                                <img className='aucardholder' src={aucardholder} alt='' />
                                                :
                                                <img className='aucardholder' src={nzcardholder} alt='' />
                                            }
                                        </div>


                                    </div>



                                    <div className="col-md-6 pl-0 mr-0 pr-0" >
                                        <div className="d-flex flex-row-begin" style={{ marginTop: 40 }}>
                                            <div className="loginbox col-auto justify-content-end  p-4 mb-5">

                                                <div className="col-12">
                                                    <div className="logmainheading mt-3">Sign in to Your <span style={{ color: '#0190f7' }}>Card Account</span> </div>
                                                </div>
                                                {loader ? <div>
                                                    <Loader />
                                                </div> :
                                                    <div>
                                                        {/* <div className='col-12 '>
                                                         
                                                            <TextField
                                                                hintText="User ID"
                                                                floatingLabelText="User ID"
                                                                id="uName"
                                                                type="text"
                                                                name="userName"
                                                                maxLength="50"
                                                                autoComplete='off'
                                                                onKeyDown={this.onEnterPress}
                                                                onChange={this.handelvalidateusername}
                                                                className="my-className"
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                autoFocus={true}
                                                                fullWidth
                                                            />

                                                        </div>
                                                        <div className='col-12 pb-2'>
                                                            <TextField
                                                                hintText="Type Your Password"
                                                                floatingLabelText="Password"
                                                                type={this.state.toggleType}
                                                                name="password"
                                                                id="loginpassword"
                                                                autoComplete='none'
                                                                maxLength="15"
                                                                onKeyDown={this.onEnterPress}
                                                                onChange={this.handelvalidatepassword}
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                fullWidth
                                                            />
                                                          
                                                            <span toggle="#loginpassword" className={`${this.state.toggleIcon} field-icon toggle-password`} style={{ position: 'absolute', top: "30px", right: "20px", cursor: "pointer" }} onClick={this.toggle} ></span>
                                                        </div>
                                                        <div className='col-12 mt-2'>
                                                            <RaisedButton
                                                                label="Login"
                                                             
                                                                type="submit"
                                                                className="btn-std"
                                                                backgroundColor="#FFCE39"
                                                                labelColor="#115876"
                                                                onClick={this.handleLogin}
                                                                buttonStyle={{ borderRadius: 50 }}
                                                                style={{ borderRadius: 50 }}
                                                   
                                                            />
                                                            {localStorage.getItem('pform') === 'AU' ?
                                                                <Link to='/au' className='simplelink' style={{ marginLeft: '15px', display: 'block' }}>  Activate / Register Card  <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i></Link>
                                                                :
                                                                <Link to='/nz' className='simplelink' style={{ marginLeft: '15px', display: 'block' }}>  Activate / Register Card  <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i></Link>
                                                            }
                                                        </div> 
                                                        
                                                        */}
                                                        <div>

                                                            <div>
                                                                <div className="col-12">

                                                                    {!this.state.userValidated ? (

                                                                        <div className="row">

                                                                            <div className="col-12">
                                                                                <TextField
                                                                                    hintText="User ID"
                                                                                    floatingLabelText="User ID"
                                                                                    id="uName"
                                                                                    type="text"
                                                                                    name="userName"
                                                                                    maxLength="50"
                                                                                    autoComplete="off"
                                                                                    onChange={this.handleValidateUsername}
                                                                                    value={this.state.userName}
                                                                                    underlineFocusStyle={styles.focusStyle}
                                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                    autoFocus={true}
                                                                                    fullWidth
                                                                                />
                                                                            </div>

                                                                            <div className="col-12 pb-2">
                                                                                <TextField
                                                                                    hintText="Type Your Password"
                                                                                    floatingLabelText="Password"
                                                                                    type={this.state.toggleType}
                                                                                    name="password"
                                                                                    id="loginpassword"
                                                                                    autoComplete="none"
                                                                                    maxLength="15"
                                                                                    onChange={this.handleValidatePassword}
                                                                                    value={this.state.password}
                                                                                    underlineFocusStyle={styles.focusStyle}
                                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                    fullWidth
                                                                                />

                                                                                <span
                                                                                    toggle="#loginpassword"
                                                                                    className={`${this.state.toggleIcon} field-icon toggle-password`}
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        top: "30px",
                                                                                        right: "20px",
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    onClick={this.toggle}
                                                                                />
                                                                            </div>

                                                                            <div className="col-12 d-flex justify-content-center mt-3 mb-2">
                                                                                <RaisedButton
                                                                                    label="Login"
                                                                                    disabled={this.state.disabled}
                                                                                    type="submit"
                                                                                    className="btn-std"
                                                                                    backgroundColor="#FFCE39"
                                                                                    labelColor="#115876"
                                                                                    onClick={this.handleLoginWithPassword}
                                                                                    buttonStyle={{
                                                                                        borderRadius: 50,
                                                                                        opacity: this.state.disabled ? 0.5 : 1
                                                                                    }}
                                                                                    style={{
                                                                                        borderRadius: "20px",
                                                                                        width: "220px"
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                        </div>

                                                                    ) : (

                                                                        <div className="row">

                                                                            <div className="col-12">
                                                                                <p
                                                                                    className="text-center mt-2"
                                                                                    style={{
                                                                                        fontSize: "14px",
                                                                                        lineHeight: "20px",
                                                                                        color: "#555"
                                                                                    }}
                                                                                >
                                                                                    A One Time Password (OTP) has been sent to your registered email
                                                                                    address
                                                                                    <b className="text-primary">
                                                                                        {" "}{this.state.maskedEmailID}
                                                                                    </b>
                                                                                    . Enter the OTP below.
                                                                                </p>
                                                                            </div>

                                                                            <div className="col-12 pb-2">
                                                                                <TextField
                                                                                    hintText="Enter OTP"
                                                                                    floatingLabelText="OTP"
                                                                                    type={this.state.toggleTypeForOtp}
                                                                                    name="otp"
                                                                                    id="loginOtp"
                                                                                    autoComplete="off"
                                                                                    maxLength="6"
                                                                                    onChange={this.handelValidateOtp}
                                                                                    value={this.state.otp}
                                                                                    underlineFocusStyle={styles.focusStyle}
                                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                    fullWidth
                                                                                />

                                                                                <span
                                                                                    toggle="#loginOtp"
                                                                                    className={`${this.state.toggleIconForOtp} field-icon toggle-password`}
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        top: "30px",
                                                                                        right: "20px",
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    onClick={this.toggleForOtp}
                                                                                />
                                                                            </div>

                                                                            <div className="col-12 mb-3">
                                                                                {this.state.timer !== 0 ? (
                                                                                    <div
                                                                                        style={{
                                                                                            textAlign: "right",
                                                                                            fontSize: "13px",
                                                                                            color: "#0190f7",
                                                                                            fontWeight: "500"
                                                                                        }}
                                                                                    >
                                                                                        Resend OTP in {this.formatTime(this.state.timer)}
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        onClick={this.handleResend}
                                                                                        style={{
                                                                                            textAlign: "right",
                                                                                            fontSize: "13px",
                                                                                            color: "#0190f7",
                                                                                            fontWeight: "600",
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                    >
                                                                                        Resend OTP
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className="col-12">
                                                                                <div
                                                                                    className="d-flex flex-column flex-sm-row"
                                                                                    style={{ gap: "10px" }}
                                                                                >

                                                                                    <div style={{ flex: 1 }}>
                                                                                        <RaisedButton
                                                                                            label="Cancel"
                                                                                            type="button"
                                                                                            backgroundColor="#d9d9d9"
                                                                                            labelColor="#333"
                                                                                            onClick={() => {
                                                                                                clearInterval(this.interval);

                                                                                                this.setState({
                                                                                                    userValidated: false,
                                                                                                    userName: "",
                                                                                                    password: "",
                                                                                                    otp: "",
                                                                                                    timer: 180,
                                                                                                    otpDisabled: true,
                                                                                                    encryptedAccountID: "",
                                                                                                    maskedEmailID: "",
                                                                                                    disabled: true
                                                                                                });
                                                                                            }}
                                                                                            buttonStyle={{
                                                                                                borderRadius: 50,
                                                                                                height: "42px"
                                                                                            }}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                borderRadius: "20px"
                                                                                            }}
                                                                                        />
                                                                                    </div>

                                                                                    <div style={{ flex: 1 }}>
                                                                                        <RaisedButton
                                                                                            label="Login With OTP"
                                                                                            type="submit"
                                                                                            disabled={this.state.otpDisabled}
                                                                                            className="btn-std"
                                                                                            backgroundColor="#FFCE39"
                                                                                            labelColor="#115876"
                                                                                            onClick={this.handleLoginWithOTP}
                                                                                            buttonStyle={{
                                                                                                borderRadius: 50,
                                                                                                height: "42px",
                                                                                                opacity: this.state.otpDisabled ? 0.5 : 1
                                                                                            }}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                borderRadius: "20px"
                                                                                            }}
                                                                                        />
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                    )}

                                                                </div>
                                                            </div>

                                                        </div>


                                                        <div className='ml-3 '>
                                                            {localStorage.getItem('pform') === 'AU' ?
                                                                <Link to='/au' className='simplelink' style={{ marginLeft: '15px', display: 'block' }}>  Activate / Register Card  <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i></Link>
                                                                :
                                                                <Link to='/nz' className='simplelink' style={{ marginLeft: '15px', display: 'block' }}>  Activate / Register Card  <i style={{ color: "#115876", fontSize: "17px" }} className="fa fa-arrow-circle-right ml-2"></i></Link>
                                                            }
                                                        </div>
                                                        <div className="col-12 mt-4">
                                                            <Link to='/forgotpassword' className='hoverlinks mr-2'> Forgot Password</Link>
                                                            <Link to='/forgotuserid' className='hoverlinks mr-2'> Forgot User ID</Link>
                                                            <Link to='/resetquestion' className='hoverlinks'> Reset Secret Q&A</Link>


                                                        </div>
                                                    </div>

                                                }
                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{ backgroundColor: 'rgb(233 248 253)' }}>
                        <div className='container bgtransparent'>
                            <div className="col-sm-12 " >
                                <div className="row mb-1  pt-5" style={{ marginTop: '-8px' }}>
                                    <div className="col-md-10 offset-md-2 text-left subdetails" >
                                        <h4>Choose the {localStorage.getItem('pform') === 'AU' ? 'Australian' : 'New Zealand'} KlickEx Money card and make <br />
                                            Shopping, spending and accessing your money simple<br />
                                            while you are away.<br /></h4>
                                    </div>

                                    <div className="col-md-12 card-images text-center" style={{ position: "relative" }}>
                                        <h2 className='mt-3 pb-2 text-center'>With KlickEx <span>Money Card<img className='moneycard' src={highlitedtext} alt='aus' /> </span>  you can...</h2>
                                    </div>
                                </div>
                                <div className="row mb-5 mt-5" >
                                    <div className="col-md-12 " >
                                        <section className="row" id="features" style={{ padding: "15px 0px" }}>
                                            <div className="col-md-4 col-sm-12 p-0 m-0 text-dark ">
                                                <div className="featuresgolden text-center wow zoomIn" data-wow-delay=".1s">
                                                    <img src={activateImg} alt='activate' />
                                                    <h4 className=" mt-3">SHOP NOW</h4>
                                                    <h5 className=" mt-3">Shop, spend & Travel <br /> with your card</h5>
                                                    <ul className="text-left">
                                                        <li className="text-left" >Accessible Anywhere</li>
                                                        <li className="text-left" >Worldwide Visa Acceptance - 24,000,000+ locations</li>
                                                        <li className="text-left" >Secure Online Shopping</li>
                                                        <li className="text-left" >Use in {localStorage.getItem('pform') === 'AU' ? 'Australia' : 'New Zealand'} and Overseas</li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-12  p-0 m-0  text-dark ">

                                                <div className="featuressky text-center wow zoomIn" data-wow-delay=".3s">
                                                    <img src={manageImg} alt='manage' />

                                                    <h4 className=" mt-3">MANAGE YOUR ACCOUNT</h4>
                                                    <h5 className=" mt-3">Self manage your card <br /> easily</h5>
                                                    <ul className="text-left">
                                                        <li className="text-left" >Check Your Card Balance</li>
                                                        <li className="text-left" >View Your Transaction History</li>
                                                        <li className="text-left" >Set and/or Change Your PIN</li>
                                                        <li className="text-left" >Update Your Personal Details</li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-12 p-0 m-0 text-dark ">
                                                <div className=" featuresblack text-center wow zoomIn" data-wow-delay=".5s">
                                                    <img src={customerImg} alt='Customer' />

                                                    <h4 className=" mt-3">CUSTOMER SERVICE</h4>
                                                    <h5 className=" mt-3">Get help when you <br />need it</h5>
                                                    <ul >
                                                        <li className="text-left" >24-7 Online Access</li>
                                                        <li className="text-left" >Email Customer Service </li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));


// WEBPACK FOOTER //
// ./src/components/register/loginnew.jsx